import React from 'react';
import { Text } from '@atlaskit/primitives';
import { getPartnerServiceDeskUrlForGenericHelp, trackPartnerServiceDeskClick } from '@css-xp/ppc-navigation';

const SupportLink = () => (
  <a
    data-testid="atlassian-support-link"
    href={getPartnerServiceDeskUrlForGenericHelp()}
    target="_blank"
    rel="noreferrer"
    onClick={trackPartnerServiceDeskClick}
  >
    {' '}
    Partner service desk
  </a>
);

export const HelpContent = ({
  contentPrefix = 'Still having trouble? Contact',
  version,
}: {
  contentPrefix?: string;
  version?: number;
}) => {
  return (
    <span>
      {contentPrefix}{' '}
      {version === 2 ? (
        <Text color="color.link">
          <SupportLink />
        </Text>
      ) : (
        <SupportLink />
      )}
    </span>
  );
};
